document.addEventListener('variant:changed', function(e){
    const selectedVariant = e.detail.selectedVariant
    const value = selectedVariant.title

    updateKoalaVariantSelector(value)
});


function updateKoalaVariantSelector(value){
    const variantSelectors = document.querySelectorAll('.koala-deal__content koala-dropdown')

    variantSelectors.forEach(selector => {
        selector.setAttribute('selected', value)
    })
}